import { Button } from '@mui/material';
import Box from '@mui/material/Box';
import MuiCard from '@mui/material/Card';
import Typography from '@mui/material/Typography';

import { styled } from '@mui/material/styles';
import { Link } from 'react-router-dom';


const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  padding: theme.spacing(4),
  marginTop: 20,
  gap: theme.spacing(2),
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  [theme.breakpoints.up('sm')]: {
    width: '450px',
  },
  ...theme.applyStyles('dark', {
    boxShadow:
      'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}));

interface SubscribeFormProps {
  productName: string,
  productId: string,
  annualProductId: string | undefined,
  productPricePerMonth: string,
  productPricePerAnnum: string | undefined,
  addFreeNotice: boolean
}

function SubscribeForm({ productName, productId, annualProductId, productPricePerMonth, productPricePerAnnum, addFreeNotice }: SubscribeFormProps) {

  return (
    <Card variant="outlined">
      <Typography
        component="h1"
        variant="h4"
        sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)', textAlign: 'center' }}
      >
        {productName}
      </Typography>
      <Box
        component="form"
        noValidate
        sx={{ display: 'flex', flexDirection: 'column', width: '100%', gap: 2 }}
      >
        <form action="https://www.scitility.com/payment/api/v1/create-checkout-session" method="POST">
          <input type="hidden" name="lookup_key" value={productId} />
          <Button type='submit' variant='contained' sx={{ width: { md: 'auto', sm: '100%' }, pl: { md: 5 }, pr: 5, ml: { md: 5, sm: 0 }, mr: { md: 5, sm: 2 }, mt: 2, mb: 2, backgroundColor: "#003366", border: '5px solid #ADFF5C' }}>Subscribe to {productName} (${productPricePerMonth}/month)</Button>
        </form>
        { (annualProductId !== undefined && productPricePerAnnum !== undefined) &&
          <form action="https://www.scitility.com/payment/api/v1/create-checkout-session" method="POST">
            <input type="hidden" name="lookup_key" value={annualProductId} />
            <Button type='submit' variant='contained' sx={{ width: { md: 'auto', sm: '100%' }, pl: { md: 5 }, pr: 5, ml: { md: 5, sm: 0 }, mr: { md: 5, sm: 2 }, mt: 2, mb: 2, backgroundColor: "#003366", border: '5px solid #ADFF5C' }}>Subscribe to {productName} (${productPricePerAnnum}/year)</Button>
          </form>

        }
        <Typography gutterBottom sx={{ fontWeight: 'medium' }}>
          You have a free account, you can activate an {productName} account that will give you individual access to the advanced features across <strong>all</strong> the data we analyse (unrestricted!).
        </Typography>
        {!addFreeNotice &&
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            With Pro+, you also get the added flexibility to analyze results at scale through a personal API key under a fair use policy.
          </Typography>
        }
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          The {productName} account will cost ${productPricePerMonth} per month (excluding applicable taxes). You can cancel your subscription at the end of every period.
        </Typography>
        {addFreeNotice &&
          <>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              If you are from a publisher, insitution or funder and you have a contract with us, contact us at hello@scitility.com and we will verify your affiliation.
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              If you are a journalist / sleuth we have free accounts. If you think you are eligible for one please contact us at <Link to='mailto:hello@scitility.com'>hello@scitility.com</Link>.
            </Typography>
          </>
        }
      </Box>
    </Card>
  )
}

export default SubscribeForm;